import { useMutation, useQueryClient } from '@tanstack/react-query';
import { outfitService } from 'shared/src/api';
import type { GetRelatedOutfitListResponse } from 'shared/src/api/goodsService/getRelatedOutfits/types';
import { queryKey } from '../../../../../constant/queryKey';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';

export const useLikeOutfit = () => {
  const queryClient = useQueryClient();
  const goodsSno = useGoodsSno();

  return useMutation({
    mutationFn: ({ sno, liked }: { sno: number; liked: boolean }) =>
      (liked
        ? outfitService.removeLike(sno)
        : outfitService.postLike(sno)
      ).then(() => ({ sno, liked: !liked })),
    onSuccess: ({ sno, liked }) => {
      queryClient.setQueryData<GetRelatedOutfitListResponse>(
        queryKey.goodsRelatedOutfit(goodsSno),
        oldData => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            item_list: oldData.item_list.map(outfit =>
              outfit.item.sno === sno
                ? {
                    ...outfit,
                    item: {
                      ...outfit.item,
                      like: {
                        count: outfit.item.like.count + (liked ? 1 : -1),
                        liked,
                      },
                    },
                  }
                : outfit,
            ),
          };
        },
      );
    },
  });
};
